import React from "react";

import Table from "../../common/Table";

const PrintTable = ({ columns, data, colWidths }) => {
  return (
    <div className="print-table-area">
      <Table data={data} columns={columns} colWidths={colWidths} />
    </div>
  );
};

export default PrintTable;
